import moment from "moment";

const DurationDisplay = ({ seconds, format = "HH:mm:ss" }) => {
  if (!seconds) return "-";
  return moment
    .utc(moment.duration(seconds, "seconds").asMilliseconds())
    .format(format);
};

export default DurationDisplay;